<figure class="loader-section section-full" [ngClass]="{hidden: !loader.on}">
	<span class="circle"></span>
	<span class="circle"></span>
	<span class="circle"></span>
	<span class="circle"></span>
</figure>